import { render, staticRenderFns } from "./AppParentMenu.vue?vue&type=template&id=f84836fa&scoped=true&"
import script from "./AppParentMenu.vue?vue&type=script&lang=js&"
export * from "./AppParentMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84836fa",
  null
  
)

export default component.exports